"use client";

import { SearchIcon } from "@/app/components/icons/SearchIcon";

interface GlobalSearchBannerProps {
  /** Number of cross-category results that matched the current query. */
  resultCount: number;
  /** Active query string — surfaced inside the "Showing X for Y" copy. */
  query: string;
  /** Clears the search query in the parent so the banner unmounts. */
  onClear: () => void;
}

/**
 * Header strip that appears above the markets grid when the user runs a
 * global search and we're showing aggregated results across categories.
 *
 * Pulled out of MarketsPageContent so the surrounding render stays
 * focused on the per-category branches. The parent decides when to mount
 * this (`isGlobalSearch && resultCount > 0`).
 */
export function GlobalSearchBanner({ resultCount, query, onClear }: GlobalSearchBannerProps) {
  return (
    <div className="mb-4 flex items-center gap-2 px-3 py-2 bg-gray-100 dark:bg-[#0f0f12] border border-gray-200 dark:border-[#1A1A1A] rounded-[5px]">
      <SearchIcon size={16} isAnimated={false} className="text-gray-500 dark:text-gray-400" />
      <span className="text-sm font-satoshi text-gray-700 dark:text-gray-300">
        Showing <strong className="text-gray-500 dark:text-gray-400">{resultCount}</strong> results for &quot;<strong>{query}</strong>&quot; across all markets
      </span>
      <button
        onClick={onClear}
        className="ml-auto text-xs font-inter-tight font-bold text-gray-500 dark:text-gray-400 hover:underline"
      >
        Clear search
      </button>
    </div>
  );
}
